// import { Global } from "./../_module/global";
import { StoreDrawer } from "./../_module/_click/storeDrawer";
import { TopSnowAnimation } from "./../_module/_animation/topSnowAnimation";
import { LetterMotion } from "./../_module/_text/letterMotion";
import { LineModal } from "./../_module/_click/lineModal";

// import { PromotionBnr } from "./../_module/_click/promotionBanner";

export const Home = {

  /**
   * funcs
   */
  init: () => {
    StoreDrawer.init()
    TopSnowAnimation.setCanvas("mv-canvas")
    Home.productArea()
    LetterMotion.init(true)
    LineModal.init();

    // if(Global.isBanner){
    //   PromotionBnr.init()
    // }
    
  },
  productArea:()=>{
    let items=document.querySelectorAll("#product-listTop .item");
    let list =document.getElementById('product-bgList')
    let lastIdx=(items.length%2==0) ? 0 : 1;
    for(let i=0,li=items.length+lastIdx;i<li;i++){
      let div = document.createElement('div');
      div.className = 'product-bgitem';
      div.dataset.scroll=true;
      div.dataset.scrollSpeed=(i%2==0) ? "1" : "2.5";
      let span = document.createElement('span');
      div.appendChild(span);
      list.appendChild(div);
    }
  }
};
